export default (payload) => ({
  type: 'UPDATE_CALL_STATE',
  payload,
});
